import React, {Fragment} from "react";
import {Menu, Transition} from "@headlessui/react";
import {ChevronDownIcon} from "@heroicons/react/solid";
import {
    CalendarIcon,
    CheckIcon, ClockIcon,
    DocumentSearchIcon, DocumentTextIcon,
    IdentificationIcon,
    UserIcon,
    XIcon
} from "@heroicons/react/outline";
import {useTranslation} from "react-i18next";
import {NEW_LEAD, QUALIFICATION, PROPOSAL, NEGOTIATION, CLOSED, LOST, BAD_TIMING, ATTEMPTED_TO_CONTACT} from "../../../constants/config";
import Loader from "../loader/loader";



function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const LeadStatusList = ({isLoading, status, onChangeStatus, isEditable = true}) => {
    const { t } = useTranslation();



    let statusStyles = {
        new_lead: {
            style: isEditable ? 'border-gray-700 text-gray-700 hover:bg-gray-700 hover:text-white' : 'border-gray-700 text-gray-700',
            title: t("app.leads.new_lead"),
            icon: UserIcon
        },
        qualification: {
            style: isEditable ? 'border-yellow-900 text-yellow-900 hover:bg-yellow-900 hover:text-white' : 'border-yellow-900 text-yellow-900',
            title: t("app.leads.qualification"),
            icon: IdentificationIcon
        },
        proposal: {
            style: isEditable ? 'border-blue-900 text-blue-900 hover:bg-blue-900 hover:text-white' : 'border-blue-900 text-blue-900',
            title: t("app.leads.proposal"),
            icon: DocumentTextIcon
        },
        negotiation: {
            style: isEditable ? 'border-yellow-700 text-yellow-700 hover:bg-yellow-700 hover:text-white' : 'border-yellow-700 text-yellow-700',
            title: t("app.leads.negotiation"),
            icon: DocumentSearchIcon
        },
        closed: {
            style: isEditable ? 'border-green-900 text-green-900 hover:bg-green-900 hover:text-white' : 'border-green-900 text-green-900',
            title: t("app.leads.closed"),
            icon: CheckIcon
        },
        lost: {
            style: isEditable ? 'border-red-900 text-red-900 hover:bg-red-900 hover:text-white' : 'border-red-900 text-red-800',
            title: t("app.leads.lost"),
            icon: XIcon
        },
        bad_timing: {
            style: isEditable ? 'border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white' : 'border-gray-900 text-gray-900',
            title: t("app.leads.bad_timing"),
            icon: ClockIcon
        },
        attempted_to_contact: {
            style: isEditable ? 'border-purple-900 text-purple-900 hover:bg-purple-900 hover:text-white' : 'border-purple-900 text-purple-900',
            title: t("app.leads.attempted_to_contact"),
            icon: CalendarIcon
        }
    };


    const getStatus = () => {
        return [NEW_LEAD, QUALIFICATION, PROPOSAL, NEGOTIATION, CLOSED,ATTEMPTED_TO_CONTACT, BAD_TIMING, LOST].filter(r => r !== status);
    }

    const IconList = ({status, className}) => {

        let IconType = statusStyles[status].icon;
        return (
            <IconType
                className={className}
                aria-hidden="true"
            />
        )
    }

    return (
        <Menu as="div" className="relative inline-block text-left">
            <div>
                <Menu.Button className={classNames(
                    "btn rounded-0",
                    statusStyles[status].style,
                )}
                >

                    {
                        isLoading ? (
                            <div className="mr-6">
                                <Loader />
                            </div>
                        ) : (
                            <IconList
                                status={status}
                                className={classNames(
                                    "w-4 h-4 mr-1 flex-shrink-0"
                                )}
                            />
                        )
                    }



                    {statusStyles[status].title}

                    {
                        isEditable && (
                            <ChevronDownIcon className="w-5 h-5 ml-4 -mr-1 text-current" aria-hidden="true"/>
                        )
                    }
                </Menu.Button>
            </div>

            {
                isEditable && (
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className="absolute right-0 w-56 mt-2 origin-top-right bg-solitude-200 divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">


                            {
                                getStatus().map((item) => (
                                    <Menu.Item key={item}>
                                        {({ active }) => (
                                            <div
                                                onClick={(() => {
                                                    onChangeStatus(item)
                                                })}
                                                className={
                                                    classNames(
                                                        active || false ? 'bg-indigo-800 text-solitude-200' : 'bg-solitude-200',
                                                        statusStyles[item].style,
                                                        'group flex  items-center w-full p-3 text-sm cursor-pointer'
                                                    )}
                                            >
                                                <IconList
                                                    status={item}
                                                    className={classNames(
                                                        'w-5 h-5 mr-2'
                                                    )}
                                                />
                                                {statusStyles[item].title}
                                            </div>
                                        )}
                                    </Menu.Item>
                                ))
                            }




                        </Menu.Items>
                    </Transition>
                )
            }


        </Menu>
    );
};
